<template>
  <div class="app-container crm-detail">
    <el-card class="box-card mariginBottom" shadow="hover">
      <div slot="header" class="clearfix">
        <span>基本信息</span>
      </div>
      <el-row class="mariginBottom">
        <el-col :span="8">
          <div class="grid-content bg-purple">用户：{{detail.nickName}}</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">备注：{{detail.remarkName}}</div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple">手机号：
            {{detail.phoneNumber}}
            <el-tooltip class="item" effect="dark" :content="detail.phoneNumber" placement="top-start">
              <el-button type="text" style="padding:0">展示</el-button>
            </el-tooltip>
          </div>
        </el-col> -->
        <el-col :span="8">
          <div class="grid-content bg-purple">员工：{{detail.replyUserName}}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">最新互动时间：{{detail.latestInteractTime}}</div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card mariginBottom" shadow="hover">
      <el-table v-loading="loading" :data="dataList">
        <el-table-column label="互动内容" min-width="150" align="left" prop="content" />
        <el-table-column label="互动人员" min-width="100" align="center" prop="nickName" />
        <el-table-column label="互动时间" min-width="170" align="center" prop="interactTime">
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="queryDetailList"
      />
    </el-card>
  </div>
</template>

<script>
import { queryDetailList, queryInteractDetail } from "@/api/saas/package"
export default {
  name: "InvoiceDetail",
  data() {
    return {
      loading: false,
      interactId: null,
      detail: {},
      dataList: [],
      queryParams: {
        interactId: 0,
        pageNum: 1,
        pageSize: 10
      },
      total: 0
    };
  },
  mounted(){
    this.queryParams.interactId = this.$route.query.interactId
    this.queryInteractDetail()
    this.queryDetailList()
  },
  methods: {
    queryInteractDetail() {
      queryInteractDetail({
        interactId: this.queryParams.interactId
      })
        .then(response => {
          this.detail = response.data
        })
        .catch(error => {
          this.loading = false;
        });
    },
    queryDetailList() {
      queryDetailList(this.queryParams)
        .then(response => {
          this.dataList = response.rows
          this.total = response.total
        })
        .catch(error => {
        });
    }
  }
};
</script>

<style lang='scss' scoped>
.mariginBottom {
  margin-bottom: 20px;
}
</style>

